// extracted by mini-css-extract-plugin
export default {"editButton":"advancesalary_editButton__V4JYd","TableBody":"advancesalary_TableBody__WXYrg"};